import './online-service.css.proxy.js';
/* src/routes/online-service.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { preloader } from "./preload.js";
import { News } from "../../_modules/news/index.js";
import { Car } from "../../_modules/car/index.js";
import Page from "../../_components/slot/Page.js";
import Wrap from "../../_components/slot/Wrap.js";
import Section from "../../_components/slot/Section.js";
import Center from "../../_components/slot/Center.js";
import Button from "../../_components/button/Simple.js";
import List from "../../_components/list/List.js";
import Item from "../../_components/list/Item.js";
import Title from "../../_components/block/Title.js";
import NewsLink from "../../_components/news/Link.js";
import CarLink from "../../_components/car/LargeLink.js";
import CTA from "../../_components/block/CTA.js";
import CTContact from "../../_components/block/CTContact.js";
import Head from "../../_components/meta/Head.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[2] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[2] = list[i];
	return child_ctx;
}

// (24:371) <Wrap>
function create_default_slot_18(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true, class: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/online_service.jpg")) attr(img, "src", img_src_value);
			attr(img, "alt", "オンライン接客実施中！");
			attr(img, "class", "svelte-glalbh");
			attr(figure, "class", "svelte-glalbh");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (24:351) <Section kind="top">
function create_default_slot_17(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_18] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 128) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (24:524) <Wrap>
function create_default_slot_16(ctx) {
	let p;
	let t0;
	let br;
	let t1;

	return {
		c() {
			p = element("p");
			t0 = text("アルベロでは、よりお気軽に車をご覧いただくためにオンライン接客サービスを開始しました。");
			br = element("br");
			t1 = text("外出が難しい方や、画像だけで判断するのが不安な方はぜひお問い合わせください。");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, "アルベロでは、よりお気軽に車をご覧いただくためにオンライン接客サービスを開始しました。");
			br = claim_element(p_nodes, "BR", {});
			t1 = claim_text(p_nodes, "外出が難しい方や、画像だけで判断するのが不安な方はぜひお問い合わせください。");
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "svelte-glalbh");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, br);
			append(p, t1);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (24:467) <Section name="オンライン接客について" en="WHAT IS THIS" kind="top">
function create_default_slot_15(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_16] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 128) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (24:690) <Wrap>
function create_default_slot_14(ctx) {
	let ul;
	let li0;
	let div0;
	let img0;
	let img0_src_value;
	let h30;
	let t0;
	let li1;
	let div1;
	let img1;
	let img1_src_value;
	let h31;
	let t1;

	return {
		c() {
			ul = element("ul");
			li0 = element("li");
			div0 = element("div");
			img0 = element("img");
			h30 = element("h3");
			t0 = text("様々な理由から外出が難しい方");
			li1 = element("li");
			div1 = element("div");
			img1 = element("img");
			h31 = element("h3");
			t1 = text("オンラインショッピングは気軽だけれど、画像だけで判断するのは不安だと感じる方");
			this.h();
		},
		l(nodes) {
			ul = claim_element(nodes, "UL", { class: true });
			var ul_nodes = children(ul);
			li0 = claim_element(ul_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			div0 = claim_element(li0_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			img0 = claim_element(div0_nodes, "IMG", { src: true, class: true });
			h30 = claim_element(div0_nodes, "H3", { class: true });
			var h30_nodes = children(h30);
			t0 = claim_text(h30_nodes, "様々な理由から外出が難しい方");
			h30_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			li0_nodes.forEach(detach);
			li1 = claim_element(ul_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			div1 = claim_element(li1_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			img1 = claim_element(div1_nodes, "IMG", { src: true, class: true });
			h31 = claim_element(div1_nodes, "H3", { class: true });
			var h31_nodes = children(h31);
			t1 = claim_text(h31_nodes, "オンラインショッピングは気軽だけれど、画像だけで判断するのは不安だと感じる方");
			h31_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img0.src !== (img0_src_value = "/images/online_1.png")) attr(img0, "src", img0_src_value);
			attr(img0, "class", "svelte-glalbh");
			attr(h30, "class", "svelte-glalbh");
			attr(div0, "class", "recommend svelte-glalbh");
			attr(li0, "class", "svelte-glalbh");
			if (img1.src !== (img1_src_value = "/images/online_2.png")) attr(img1, "src", img1_src_value);
			attr(img1, "class", "svelte-glalbh");
			attr(h31, "class", "svelte-glalbh");
			attr(div1, "class", "recommend svelte-glalbh");
			attr(li1, "class", "svelte-glalbh");
			attr(ul, "class", "svelte-glalbh");
		},
		m(target, anchor) {
			insert(target, ul, anchor);
			append(ul, li0);
			append(li0, div0);
			append(div0, img0);
			append(div0, h30);
			append(h30, t0);
			append(ul, li1);
			append(li1, div1);
			append(div1, img1);
			append(div1, h31);
			append(h31, t1);
		},
		d(detaching) {
			if (detaching) detach(ul);
		}
	};
}

// (24:639) <Section name="こんな方におすすめ！" en="RECOMMENDED FOR...">
function create_default_slot_13(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 128) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (24:961) <Center>
function create_default_slot_12(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				name: "早速相談してみる！",
				action: "/contact?subject=オンライン接客",
				type: "link"
			}
		});

	return {
		c() {
			create_component(button.$$.fragment);
		},
		l(nodes) {
			claim_component(button.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (24:955) <Wrap>
function create_default_slot_11(ctx) {
	let center;
	let current;

	center = new Center({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(center.$$.fragment);
		},
		l(nodes) {
			claim_component(center.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(center, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const center_changes = {};

			if (dirty & /*$$scope*/ 128) {
				center_changes.$$scope = { dirty, ctx };
			}

			center.$set(center_changes);
		},
		i(local) {
			if (current) return;
			transition_in(center.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(center.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(center, detaching);
		}
	};
}

// (24:932) <Section kind="bottom">
function create_default_slot_10(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 128) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (24:1075) <Section background="/images/back_contact.jpg" kind="gapless">
function create_default_slot_9(ctx) {
	let ctcontact;
	let current;

	ctcontact = new CTContact({
			props: { color: "red", position: "right" }
		});

	return {
		c() {
			create_component(ctcontact.$$.fragment);
		},
		l(nodes) {
			claim_component(ctcontact.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(ctcontact, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(ctcontact.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ctcontact.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(ctcontact, detaching);
		}
	};
}

// (24:1331) <Item columns="4">
function create_default_slot_8(ctx) {
	let newslink;
	let current;

	newslink = new NewsLink({
			props: { newsItem: /*item*/ ctx[2], reverse: true }
		});

	return {
		c() {
			create_component(newslink.$$.fragment);
		},
		l(nodes) {
			claim_component(newslink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(newslink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const newslink_changes = {};
			if (dirty & /*news*/ 1) newslink_changes.newsItem = /*item*/ ctx[2];
			newslink.$set(newslink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(newslink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(newslink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(newslink, detaching);
		}
	};
}

// (24:1311) {#each news as item}
function create_each_block_1(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "4",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (24:1305) <List>
function create_default_slot_7(ctx) {
	let each_1_anchor;
	let current;
	let each_value_1 = /*news*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*news*/ 1) {
				each_value_1 = /*news*/ ctx[0];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (24:1299) <Wrap>
function create_default_slot_6(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (24:1199) <Section name="お知らせ" en="NEWS" more="{['/news', 'すべてのお知らせを見る']}" background="/images/back_news.jpg">
function create_default_slot_5(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (24:1567) <Item columns="2">
function create_default_slot_4(ctx) {
	let carlink;
	let current;
	carlink = new CarLink({ props: { car: /*item*/ ctx[2] } });

	return {
		c() {
			create_component(carlink.$$.fragment);
		},
		l(nodes) {
			claim_component(carlink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(carlink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const carlink_changes = {};
			if (dirty & /*cars*/ 2) carlink_changes.car = /*item*/ ctx[2];
			carlink.$set(carlink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(carlink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(carlink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(carlink, detaching);
		}
	};
}

// (24:1547) {#each cars as item}
function create_each_block(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "2",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (24:1541) <List>
function create_default_slot_3(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*cars*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*cars*/ 2) {
				each_value = /*cars*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (24:1535) <Wrap>
function create_default_slot_2(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (24:1434) <Section name="車両一覧" en="STOCK" more="{['/stock', 'すべての車両を見る']}" background="/images/back_stock.jpg">
function create_default_slot_1(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (24:251) <Page>
function create_default_slot(ctx) {
	let title;
	let section0;
	let section1;
	let section2;
	let section3;
	let section4;
	let section5;
	let section6;
	let current;

	title = new Title({
			props: {
				title: "オンライン接客",
				en: "ONLINE SERVICE",
				background: "/images/back_online_title.jpg"
			}
		});

	section0 = new Section({
			props: {
				kind: "top",
				$$slots: { default: [create_default_slot_17] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				name: "オンライン接客について",
				en: "WHAT IS THIS",
				kind: "top",
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				name: "こんな方におすすめ！",
				en: "RECOMMENDED FOR...",
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				kind: "bottom",
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				background: "/images/back_contact.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	section5 = new Section({
			props: {
				name: "お知らせ",
				en: "NEWS",
				more: ["/news", "すべてのお知らせを見る"],
				background: "/images/back_news.jpg",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	section6 = new Section({
			props: {
				name: "車両一覧",
				en: "STOCK",
				more: ["/stock", "すべての車両を見る"],
				background: "/images/back_stock.jpg",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(title.$$.fragment);
			create_component(section0.$$.fragment);
			create_component(section1.$$.fragment);
			create_component(section2.$$.fragment);
			create_component(section3.$$.fragment);
			create_component(section4.$$.fragment);
			create_component(section5.$$.fragment);
			create_component(section6.$$.fragment);
		},
		l(nodes) {
			claim_component(title.$$.fragment, nodes);
			claim_component(section0.$$.fragment, nodes);
			claim_component(section1.$$.fragment, nodes);
			claim_component(section2.$$.fragment, nodes);
			claim_component(section3.$$.fragment, nodes);
			claim_component(section4.$$.fragment, nodes);
			claim_component(section5.$$.fragment, nodes);
			claim_component(section6.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(title, target, anchor);
			mount_component(section0, target, anchor);
			mount_component(section1, target, anchor);
			mount_component(section2, target, anchor);
			mount_component(section3, target, anchor);
			mount_component(section4, target, anchor);
			mount_component(section5, target, anchor);
			mount_component(section6, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 128) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 128) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 128) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 128) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const section4_changes = {};

			if (dirty & /*$$scope*/ 128) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
			const section5_changes = {};

			if (dirty & /*$$scope, news*/ 129) {
				section5_changes.$$scope = { dirty, ctx };
			}

			section5.$set(section5_changes);
			const section6_changes = {};

			if (dirty & /*$$scope, cars*/ 130) {
				section6_changes.$$scope = { dirty, ctx };
			}

			section6.$set(section6_changes);
		},
		i(local) {
			if (current) return;
			transition_in(title.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			transition_in(section5.$$.fragment, local);
			transition_in(section6.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(title.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			transition_out(section5.$$.fragment, local);
			transition_out(section6.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(title, detaching);
			destroy_component(section0, detaching);
			destroy_component(section1, detaching);
			destroy_component(section2, detaching);
			destroy_component(section3, detaching);
			destroy_component(section4, detaching);
			destroy_component(section5, detaching);
			destroy_component(section6, detaching);
		}
	};
}

function create_fragment(ctx) {
	let head;
	let page;
	let current;

	head = new Head({
			props: {
				title: "オンライン接客 | 株式会社アルベロ | 群馬県の輸入車販売店",
				path: "/online-service",
				description: "株式会社アルベロのオンライン接客についての説明です。株式会社アルベロは、群馬県前橋市にある自動車販売店です。輸入車を中心に、高品質な車両を新車、中古車問わずどんな車両でも常時取り揃えております。自社工場も完備しているので、購入後のメンテナンスもお任せください。",
				image: "/images/keyvisual.jpg"
			}
		});

	page = new Page({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(head.$$.fragment);
			create_component(page.$$.fragment);
		},
		l(nodes) {
			claim_component(head.$$.fragment, nodes);
			claim_component(page.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(head, target, anchor);
			mount_component(page, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const page_changes = {};

			if (dirty & /*$$scope, cars, news*/ 131) {
				page_changes.$$scope = { dirty, ctx };
			}

			page.$set(page_changes);
		},
		i(local) {
			if (current) return;
			transition_in(head.$$.fragment, local);
			transition_in(page.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(head.$$.fragment, local);
			transition_out(page.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(head, detaching);
			destroy_component(page, detaching);
		}
	};
}

const preload = preloader;

function instance($$self, $$props, $$invalidate) {
	let { news = [] } = $$props;
	let { cars = [] } = $$props;

	$$self.$$set = $$props => {
		if ("news" in $$props) $$invalidate(0, news = $$props.news);
		if ("cars" in $$props) $$invalidate(1, cars = $$props.cars);
	};

	return [news, cars];
}

class Online_service extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { news: 0, cars: 1 });
	}
}

export default Online_service;
export { preload };
//# sourceMappingURL=online-service.js.map
